export class WorkflowSpecificationModel {
    version?: number = 3;
    workflow: WorkflowSpecificationDetail = new WorkflowSpecificationDetail();
}

export class WorkflowSpecificationDetail {
    id: string;
    flow: WorkflowNode[] = [];
}

export class WorkflowNode {
    id: string;
    run: WorkflowRunningDetail = new WorkflowRunningDetail();
}

export class WorkflowRunningDetail {
    module: string;

    input?: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-redundant-type-constituents
        [index: string]: WorkflowInput | any;
    } = {};
}

export class WorkflowInput {
    operation_id: string;
    output: string;
}
